import {
  Component,
  inject,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { IonLabel } from '@ionic/angular/standalone';
import { ModeControlMultipleComponent } from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import noUiSlider from 'nouislider';

@Component({
  selector: 'app-p00076-constance-controle',
  templateUrl: './p00076-constance-controle.component.html',
  styleUrls: ['./p00076-constance-controle.component.scss'],
  imports: [IonLabel, ModeControlMultipleComponent, TranslatePipe],
})
export class P00076ConstanceControleComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('slider', { static: false }) sliderElement!: ElementRef;

  private slideModalcontroller: SlideModalController =
    inject(SlideModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;
  private slider: any;

  // Valeurs par défaut des curseurs
  public sliderValues = [0, 50, 100];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  ngAfterViewInit() {
    this.initializeSlider();
  }

  private initializeSlider() {
    this.sliderValues = [
      this.actionStack!.getValue('coPValeurNiveauEauMinAlarme'),
      this.actionStack!.getValue('coPConsigneRegulation'),
      this.actionStack!.getValue('coPValeurNiveauEauMaxAlarme'),
    ];

    if (this.sliderElement?.nativeElement) {
      this.slider = noUiSlider.create(this.sliderElement.nativeElement, {
        start: this.sliderValues,
        range: {
          min: -10,
          max: 110,
        },
        connect: [true, false, false, true],
        padding: [10, 10],
        step: 10,
        margin: 10,
        behaviour: 'drag',
        tooltips: [
          {
            to: function (value: number) {
              return Math.round(value) + '%';
            },
          },
          {
            to: function (value: number) {
              return Math.round(value) + '%';
            },
          },
          {
            to: function (value: number) {
              return Math.round(value) + '%';
            },
          },
        ],
      });

      // Événement déclenché à chaque modification
      this.slider.on('change', (values: string[], handle: number) => {
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Parametrage,
          'coPValeurNiveauEauMinAlarme',
          values[0],
        );
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Parametrage,
          'coPValeurNiveauEauMaxAlarme',
          values[1],
        );
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Constance_Parametrage,
          'coPConsigneRegulation',
          values[2],
        );
        this.actionStack!.commit();
      });

      // Contrainte : empêcher les curseurs de se dépasser
      this.slider.on('slide', (values: string[], handle: number) => {
        const numValues = values.map((v) => parseFloat(v));

        // Vérifier les contraintes
        if (handle === 0 && numValues[0] > numValues[1]) {
          this.slider.setHandle(0, numValues[1] - 1, false);
        }
        if (handle === 1) {
          if (numValues[1] < numValues[0]) {
            this.slider.setHandle(1, numValues[0] + 1, false);
          }
          if (numValues[1] > numValues[2]) {
            this.slider.setHandle(1, numValues[2] - 1, false);
          }
        }
        if (handle === 2 && numValues[2] < numValues[1]) {
          this.slider.setHandle(2, numValues[1] + 1, false);
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) {
      this.slider.destroy();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
